export default __webpack_public_path__ + "images/0def6275d37f525f277cbe1a3450b766.png";